import React from 'react'
import { isString } from 'lodash'
import { Modal, Glyphicon } from 'react-bootstrap'
import { post } from 'superagent'
import { browserHistory, Link } from 'react-router'

import { getText } from '../lib/text.js'
import Button from '../components/Button.jsx'
import { l } from '../../lib/Tools.js'
import TripNamePicker from './TripNamePicker'

const Spinner = ({ text }) => (
  <Modal show bsSize="small">
    <Modal.Body>{text}</Modal.Body>
  </Modal>
)

const voucherActivities = (route, activities) => {
  const activitiesErrors = []
  const { agenda } = route
  agenda.filter(item => (item.type == "activity" && activities[item.id].hasVoucher)).forEach(item => {
    const a = activities[item.id]

    if (!a.voucherDescription) {
      activitiesErrors.push({
        cadena : `${a.name}: ` + getText(`Falta por añadir la descripcion.`),
        link: (
          <Link to={`/private/activity/${encodeURIComponent(a._id)}?`}>
            {getText(" Ir a la actividad")}
          </Link>)
      })
    }

    if (!isString(a.voucherFiles.image1) || !isString(a.voucherFiles.image2)) {
      activitiesErrors.push({
        cadena: `${a.name}: ` + getText(`Falta por añadir alguna imagen.`),
        link :(
          <Link to={`/private/activity/${encodeURIComponent(a._id)}?`}>
            {getText(" Ir a la actividad")}
          </Link>)
      })
    }
  })
  return activitiesErrors
}

class Vouchers extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      nameKey: null,
      nameValue: null
    }
  }

  generate(id) {
    this.setState({generating: true})
    post(`/api/voucher/${id}`)
      .send({ name: this.state.nameValue })
      .end((e, r) => {
        this.setState({ modal: null })
        if (r && r.statusCode === 412) {
          alert(l(`${getText("error_missing_files")} ${r.body.missingFilesNames.join(", ")}`))
        }
        else if (r.statusCode === 401) {
          alert(getText("error_expired_login"))
          browserHistory.push("/login")
        }
        else if (e) {
          alert(`${getText("error_pdf_generation")} ${e}`)
          console.error(e)
          console.error(r)
        }
        else {
          console.log("got pdf: " + r.body.resultFile)
          this.setState({ generating: false, url: `/${r.body.resultFile}` })
        }
      })
  }


  render() {
    const { trip, route, activities, close, cancel} = this.props
    const { url, generating } = this.state
    const errors = voucherActivities(route, activities)
    //const act = Activities.filter(activity => activity.hasVouche)

    const vouchersCount = route.agenda.filter(item => (item.type == "activity" && activities[item.id].hasVoucher)).length

    if (!generating && !url) return (
      <Modal show onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>{getText("Vouchers")}(<Glyphicon glyph="star" />)</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 700, overflowY: "scroll" }}>
          {
            vouchersCount == 0 && (<span>Este viaje no tiene vouchers.</span>)
          }

          {
            errors.length > 0 && (
              <ul>
                {errors.map((e, i) => <li key={i}>{e.cadena}{e.link}</li>)}
              </ul>
            )
          }

          {
            errors.length == 0 && (
              <TripNamePicker
                trip={trip}
                value={this.state.nameKey}
                onChange={(nameKey, nameValue) => {
                  this.setState({ nameKey, nameValue })
                }}
                config="vouchers"
              />
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={close}>Cerrar</Button>
          <Button
            bsStyle="primary"
            disabled={errors.length > 0}
            onClick={() => this.generate(trip._id)}
          >
            Generar
          </Button>
        </Modal.Footer>
      </Modal>
    )

    if (generating) return (
      <Spinner text={getText("Generando documento...")} />
    )

    if (url) return (
      <Result
        trip={trip}
        cancel={cancel}
        url={url}
      />
    )

    return null
  }
}

const Result = ({ trip, cancel, url, advanceStatus }) => (
  <Modal show onHide={cancel}>
    <Modal.Header>
      Documento generado correctamente
    </Modal.Header>
    <Modal.Body>
      <output>
        {document.location.origin + url}
      </output>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={cancel}>Cerrar</Button>
      <Button
        bsStyle="primary"
        onClick={() => window.open(url)}
      >
        Descargar documento
      </Button>
    </Modal.Footer>
  </Modal>
)

export default Vouchers
